import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { RolWidget } from '../_models/rol-widget';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RolWidgetsServices {

  private serviceURL = AppSettings.rutServiciosASI + '/api/rolesWidgets/';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  getAll() {
    return this.httClient.get( this.serviceURL ).pipe( map( res => res as RolWidget[] ) );
  }

  getAllByRol( id: string ): Observable<RolWidget[]> {
    return this.httClient.get( this.serviceURL + 'buscarRol/' + id ).pipe( map( res => res as RolWidget[] ) );
  }

  getAllByUser( id: string ): Observable<RolWidget[]> {
    return this.httClient.get( this.serviceURL + 'usuario/' + id ).pipe( map( res => res as RolWidget[] ) );
  }

  add( f: RolWidget ) {
    f.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.serviceURL, f )
      .pipe( map( res => res as any ) );
  }

  update( f: RolWidget ) {
    f.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.serviceURL, JSON.stringify( f ) ).pipe( map( res => res as any ) );
  }

  get( id: string ) {
    return this.httClient.get( this.serviceURL + 'buscarId/' + id )
      .pipe( map( res => res as RolWidget ) );
  }

  handleError( error: any ): Promise<any> {
    console.error( 'Error:', error );
    return Promise.reject( error.message || error );
  }

}
